<div
  *ngIf="form"
  class="gl-forms__container {{ containerClass }}"
  [ngClass]="{ 'full-width': config.enableGridColCard || config.enableFullWidthForm }"
>
  <form
    [formGroup]="form"
    [ngClass]="{
      'gl-forms__section': !config.disableCard,
      'gl-forms__disable-section': config.disableCard
    }"
  >
    <div *ngIf="title" class="gl-forms__title">
      {{ title | translate }}
    </div>
    <div *ngIf="subtitle" class="gl-forms__subtitle">
      {{ subtitle | translate }}
    </div>
    <div class="gl-grid-form" [ngClass]="{ 'gl-grid-form__cols': config.enableGridColCard }">
      <ng-container *ngFor="let question of questions">
        <lms-question
          class="{{ question?.class || 'col-1' }}"
          [question]="question"
          [form]="form"
          [action]="action"
          [ngClass]="{ 'display-none': question?.hidden }"
        >
          <ng-content select="[form-html]" form-html></ng-content>
        </lms-question>
      </ng-container>
    </div>
    <div class="gl-grid-form__buttons" [ngClass]="{ section: !config.disableCard }">
      <ng-content select="[form-actions-before]"></ng-content>
      <gl-button
        *ngIf="!isFormEmpty && !config.hideSubmit"
        color-primary
        text="{{ config.submitLabel | translate }}"
        (onClick)="onSubmit()"
        [disabled]="submitDisabled"
      ></gl-button>
    </div>
  </form>
</div>
